export default class Exhibitor {

	constructor(id, attr) {
		this.id = id;

		this.name = attr.name; // only used for MX so far
		this.domain = attr.domain;
		this.logo = attr.logo_file;

		// Contains ticketing info, and maybe other things in the future
		this.doc = attr.doc;

		// add other theater attributes here
	}

}
